/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-17 15:43:31
 * @LastEditors: lihuiping lihuiping@yuouhui.com
 * @LastEditTime: 2025-09-08 15:20:36
 * @FilePath: /mzc-frontend-pc/packages/share/utils/reg.ts
 * @Description: 常用正则集合
 *
 */

export default {
  IdCardNumber: /^\d{17}[\d|xX]$/, //身份证号正则
  numAndLetter: /^[A-Za-z0-9]+$/, // 数字和字母，至少1位
  num: /^\d+$/, //数字，至少1位
  telnum: /^1\d{10}$|^(\d{3,4}-?)?\d{7,8}$/, // 手机号和座机号
  simplePwd: /^\d{6}$/, //6位数字密码
  userName: /^[A-Za-z\d_]+$/, //数字字母下划线
  phone: /^1\d{10}$/, // 手机号
  api: /^[A-Za-z\/_\-0-9]+$/, // api路径
  integer: /^[0-9]+$/, // 包括0的正整数
//   只能填写0-1的任意数值，支持两位小数
  num0To1: /^(0(\.\d{1,2})?|1(\.00?)?)$/,
  //   0到 9 的整数
  num0To9: /^[0-9]$/,
  //大于 0 的整数
  greaterThan0: /^[1-9]+[0-9]*$/,
  yearAndMonth: /^\d{4}-(0[1-9]|1[0-2])$/,
  mail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, //邮箱的正则
  integer1: /^[1-9]+[0-9]*$/, // 正整数不包括0
  maxTwoNumber: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, //最多2位小数,包含0
  maxTwoNumberGreaterThan0: /^([1-9]\d*(\.\d{1,2})?|0\.\d{1,2})$/, //最多2位小数,大于0
  maxThreeNumber: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,3})?$/, //最多3位小数
  receiverName: /^(?!.*(先生|小姐))(?!^小)(?!.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9])[a-zA-Z\u4e00-\u9fa5]{2,16}$/, //收货人的正则，不得包含“先生、小姐”，不得以“小”开头，不得输入特殊字符或数字，至少2个字，最多16个字
  numAndComma: /^(\d+)(,\d+)*$/, //多个数字用英文逗号隔开
  pwd: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, //至少8个字符，包含大写字母，小写字母和数字，不能包含特殊字符
  nwePwd: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}|:"<>?~`])[^\u4e00-\u9fa5]{10,16}$/, //密码10-16位，包含大小写字母、数字、特殊字符，不能包含中文
  specialLetter: /[`~!@#$%^*_?:{},.\/;[]()+]|[·！#￥——：；“”‘、，|《。》？、【】（）]/, //特殊字符
  socialCode: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/, //统一社会信用代码由18位数字或者大写字母组成，但是字母不包括 I、O、Z、S、V
  chinese: /[\u4e00-\u9fa5]/, //中文正则
};
